import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterLinkDetectorDirective } from 'app/core/directives/router-link-detector.directive';
import { IconLink } from 'app/core/models/icon-link.model';
import { FacebookIcon } from '../../../../assets/icons/facebook/facebook';
import { InstagramIcon } from '../../../../assets/icons/instagram/instagram';
import { LinkedinIcon } from '../../../../assets/icons/linkedin/linkedin';
import { YoutubeIcon } from '../../../../assets/icons/youtube/youtube';
import { CmsMediaPrefixPipe } from '../../../core/pipes/cms-media-prefix.pipe';
import { NgOptimizedImage } from '@angular/common';
import { ShebaGtmModule } from 'app/core/services/google-tag-manager/gtm.directive';

@Component({
  selector: 'sheba-social-media-links',
  templateUrl: 'social-media-links.component.html',
  host: {
    class: 'flex gap-2'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatRippleModule,
    FacebookIcon,
    InstagramIcon,
    LinkedinIcon,
    YoutubeIcon,
    CmsMediaPrefixPipe,
    RouterLinkDetectorDirective,
    NgOptimizedImage,
    ShebaGtmModule
  ]
})
export class ShebaSocialMediaLinksComponent {
  links = input.required<IconLink[]>();
  darkMode = input<boolean>(false)

}
